<main>

    <section class="heroHeader pb-md-5">
        <div class="customContainer container-fluid heroContainer">
            <img src="./assets/img/hero/tyre-extended-warranty.jpg" alt="ALPHERA Top Up Cover" class="img-fluid">
            <div class="container">
                <div class="containerWrapper position-relative">
                    <div class="heroCopy">
                        <h1>ALPHERA Tyre & Extended Warranty Boost</h1>
                        <p>Enjoy cover from the unexpected for longer than you’d expect with the option to add a boost with Tyre and Extended Warranty cover. This product is suitable for new or pre-owned vehicles. </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="introSec bgPattern">
        <div class="container">
            <div class="containerWrapper">
                <div class="breadCrumb">
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/insurance">Insurance</a></li>
                        <li><a routerLink="/insurance/top-up-cover">ALPHERA Tyre & Extended Warranty Boost</a></li>
                    </ul>
                </div>
                <!-- <h3>Protect yourself from vehicle finance settlement shortfalls</h3>
                <p>Ensure nothing interrupts your journey with insurance engineered to protect you from vehicle finance settlement shortfalls. If your vehicle is stolen or written off, we’ll settle the difference between your comprehensive insurance pay-out and the amount owing on your credit agreement.</p> -->
            </div>
        </div>
    </section>

    <section class="pTB teasersSec">
        <div class="container">
            <div class="containerWrapper">
                <h3>Prolonged peace-of-mind</h3>
                <p>
                    Prolong your peace of mind with Tyre & Extended Warranty Boost from ALPHERA Insurance. You have access to a selection of cover options that shield your vehicle and tyres from unexpected expenses once your Manufacturer Warranty has expired. Just choose the package that suits you based on the age and mileage of your vehicle. 
                </p>
                <br><br>
                <h3>Cover Options</h3>
                <p><strong>Extended Warranty:</strong></p>
                <div class="row">
                    <div class="col-md-6 col-lg-4">
                        <div class="teaserItem">
                            <div class="teaserImg"><img src="./assets/img/teasers/tyre-extended-1.jpg" alt="ALPHERA Top-Up Cover"
                                    class="img-fluid"></div>
                            <div class="teaserDescription">
                                <h3>Extended Warranty</h3>
                                <p>Vehicles less than 5 (Five) years old with less than 100 000km (Kilometres) recorded 
                                    on the odometer. The Vehicle must be under the original Manufacturer’s Warranty or 
                                    Maintenance Plan and must have a full and up to date service history.
                                     </p>
                                <a href="./assets/files/Tyre_and_Extended_Warranty_Boost.pdf" class="simpleLink">Download Brochure</a>
                            </div>
                        </div>
                    </div>
                </div>
                <p><strong>Pre-Owned Warranty:</strong></p>
                <div class="row">
                    <div class="col-md-6 col-lg-4">
                        <div class="teaserItem">
                            <div class="teaserImg"><img src="./assets/img/teasers/tyre-extended-2.jpg" alt="ALPHERA Top-Up Cover"
                                    class="img-fluid"></div>
                            <div class="teaserDescription">
                                <h3>Executive</h3>
                                <p>Vehicles less than 5 (Five) years old with less than 100 000km (Kilometres) recorded 
                                    on the odometer.                                    
                                     </p>
                                <a href="./assets/files/Tyre_and_Extended_Warranty_Boost.pdf" class="simpleLink">Download Brochure</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="teaserItem">
                            <div class="teaserImg"><img src="./assets/img/teasers/tyre-extended-3.jpg" alt="ALPHERA Top-Up Cover"
                                    class="img-fluid"></div>
                            <div class="teaserDescription">
                                <h3>Prestige</h3>
                                <p>Vehicles less than 7 (Seven) years old with less than 200 000km (Kilometres) 
                                    recorded on the odometer.                                                                        
                                     </p>
                                <a href="./assets/files/Tyre_and_Extended_Warranty_Boost.pdf" class="simpleLink">Download Brochure</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="teaserItem">
                            <div class="teaserImg"><img src="./assets/img/teasers/tyre-extended-4.jpg" alt="ALPHERA Top-Up Cover"
                                    class="img-fluid"></div>
                            <div class="teaserDescription">
                                <h3>Elegant</h3>
                                <p>Vehicles less than 10 (Ten) years old with less than 220 000km (Kilometres) recorded 
                                    on the odometer.                                                                                                           
                                     </p>
                                <a href="./assets/files/Tyre_and_Extended_Warranty_Boost.pdf" class="simpleLink">Download Brochure</a>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br><br>
                ALPHERA Financial Services is a Division of BMW Financial Services (South Africa) (Pty) Ltd, an Authorised Financial Services Provider (FSP 4623) and Registered Credit Provider (NCRCP2341).
            </div>
        </div>
    </section>
</main>